import { render, staticRenderFns } from "./tableAction.vue?vue&type=template&id=147f969a&scoped=true&"
import script from "./tableAction.vue?vue&type=script&lang=js&"
export * from "./tableAction.vue?vue&type=script&lang=js&"
import style0 from "./tableAction.vue?vue&type=style&index=0&id=147f969a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147f969a",
  null
  
)

export default component.exports